// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_33f8d0a0"};